var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0H3.75001C1.67998 0.00249609 0.00249609 1.67998 0 3.75001V14.25C0.00249609 16.32 1.67998 17.9975 3.75001 18H14.25C16.32 17.9975 17.9975 16.32 18 14.25V3.75001C17.9975 1.67998 16.32 0.00249609 14.25 0ZM15 6.05925L8.0595 12.9998C7.47383 13.5857 6.52409 13.5859 5.93817 13.0002C5.93803 13 5.93789 12.9999 5.93775 12.9998L2.99999 10.0628C2.7065 9.76929 2.7065 9.29348 2.99999 9.00004C3.29347 8.70659 3.76928 8.70655 4.06273 9.00004L6.99971 11.937L13.941 4.99651C14.2344 4.70408 14.7094 4.70493 15.0018 4.99837C15.2943 5.29186 15.2935 5.76682 15 6.05925Z",
    fill: "#C2C6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.84ce033a5826ef68f2ea2812803b6922.svg";
export { ForwardRef as ReactComponent };